// Album Icon
import PathBG_education_0001 from '../assets/graphics/jpeg/path_background/PathBG_education_0001.jpg';
import PathBG_education_0002 from '../assets/graphics/jpeg/path_background/PathBG_education_0002.jpg';
import PathBG_education_0003 from '../assets/graphics/jpeg/path_background/PathBG_education_0003.jpg';
import PathBG_education_0004 from '../assets/graphics/jpeg/path_background/PathBG_education_0004.jpg';
import PathBG_education_0005 from '../assets/graphics/jpeg/path_background/PathBG_education_0005.jpg';
import PathBG_education_0006 from '../assets/graphics/jpeg/path_background/PathBG_education_0006.jpg';
import PathBG_education_0007 from '../assets/graphics/jpeg/path_background/PathBG_education_0007.jpg';
import PathBG_education_0008 from '../assets/graphics/jpeg/path_background/PathBG_education_0008.jpg';
import PathBG_education_0009 from '../assets/graphics/jpeg/path_background/PathBG_education_0009.jpg';
import PathBG_education_0010 from '../assets/graphics/jpeg/path_background/PathBG_education_0010.jpg';
import PathBG_education_0011 from '../assets/graphics/jpeg/path_background/PathBG_education_0011.jpg';
import PathBG_education_0012 from '../assets/graphics/jpeg/path_background/PathBG_education_0012.jpg';
import PathBG_education_0013 from '../assets/graphics/jpeg/path_background/PathBG_education_0013.jpg';
import PathBG_education_0014 from '../assets/graphics/jpeg/path_background/PathBG_education_0014.jpg';
import PathBG_education_0015 from '../assets/graphics/jpeg/path_background/PathBG_education_0015.jpg';
import PathBG_education_0016 from '../assets/graphics/jpeg/path_background/PathBG_education_0016.jpg';
import PathBG_enterprise_0001 from '../assets/graphics/jpeg/path_background/PathBG_enterprise_0001.jpg';
import PathBG_enterprise_0002 from '../assets/graphics/jpeg/path_background/PathBG_enterprise_0002.jpg';
import PathBG_enterprise_0003 from '../assets/graphics/jpeg/path_background/PathBG_enterprise_0003.jpg';
import PathBG_enterprise_0004 from '../assets/graphics/jpeg/path_background/PathBG_enterprise_0004.jpg';
import PathBG_enterprise_0005 from '../assets/graphics/jpeg/path_background/PathBG_enterprise_0005.jpg';
import PathBG_enterprise_0006 from '../assets/graphics/jpeg/path_background/PathBG_enterprise_0006.jpg';
import PathBG_enterprise_0007 from '../assets/graphics/jpeg/path_background/PathBG_enterprise_0007.jpg';
import PathBG_enterprise_0008 from '../assets/graphics/jpeg/path_background/PathBG_enterprise_0008.jpg';
import PathBG_enterprise_0009 from '../assets/graphics/jpeg/path_background/PathBG_enterprise_0009.jpg';
import PathBG_enterprise_0010 from '../assets/graphics/jpeg/path_background/PathBG_enterprise_0010.jpg';
import PathBG_enterprise_0011 from '../assets/graphics/jpeg/path_background/PathBG_enterprise_0011.jpg';
import PathBG_enterprise_0012 from '../assets/graphics/jpeg/path_background/PathBG_enterprise_0012.jpg';
import PathBG_enterprise_0013 from '../assets/graphics/jpeg/path_background/PathBG_enterprise_0013.jpg';
import PathBG_enterprise_0014 from '../assets/graphics/jpeg/path_background/PathBG_enterprise_0014.jpg';
import PathBG_enterprise_0015 from '../assets/graphics/jpeg/path_background/PathBG_enterprise_0015.jpg';
import PathBG_enterprise_0016 from '../assets/graphics/jpeg/path_background/PathBG_enterprise_0016.jpg';
import PathBG_entertainment_0001 from '../assets/graphics/jpeg/path_background/PathBG_entertainment_0001.jpg';
import PathBG_entertainment_0002 from '../assets/graphics/jpeg/path_background/PathBG_entertainment_0002.jpg';
import PathBG_entertainment_0003 from '../assets/graphics/jpeg/path_background/PathBG_entertainment_0003.jpg';
import PathBG_entertainment_0004 from '../assets/graphics/jpeg/path_background/PathBG_entertainment_0004.jpg';
import PathBG_entertainment_0005 from '../assets/graphics/jpeg/path_background/PathBG_entertainment_0005.jpg';
import PathBG_entertainment_0006 from '../assets/graphics/jpeg/path_background/PathBG_entertainment_0006.jpg';
import PathBG_entertainment_0007 from '../assets/graphics/jpeg/path_background/PathBG_entertainment_0007.jpg';
import PathBG_entertainment_0008 from '../assets/graphics/jpeg/path_background/PathBG_entertainment_0008.jpg';
import PathBG_entertainment_0009 from '../assets/graphics/jpeg/path_background/PathBG_entertainment_0009.jpg';
import PathBG_entertainment_0010 from '../assets/graphics/jpeg/path_background/PathBG_entertainment_0010.jpg';
import PathBG_entertainment_0011 from '../assets/graphics/jpeg/path_background/PathBG_entertainment_0011.jpg';
import PathBG_entertainment_0012 from '../assets/graphics/jpeg/path_background/PathBG_entertainment_0012.jpg';
import PathBG_entertainment_0013 from '../assets/graphics/jpeg/path_background/PathBG_entertainment_0013.jpg';
import PathBG_entertainment_0014 from '../assets/graphics/jpeg/path_background/PathBG_entertainment_0014.jpg';
import PathBG_entertainment_0015 from '../assets/graphics/jpeg/path_background/PathBG_entertainment_0015.jpg';
import PathBG_entertainment_0016 from '../assets/graphics/jpeg/path_background/PathBG_entertainment_0016.jpg';

// enum BackgroundDraftCategory {
//   Entertainment = 'entertainment',
//   Education = 'education',
//   Enterprise = 'enterprise',
// }

// const numberOfCategoryPathImages = 16;

export const PathBG_EducationSet: string[] = [
  PathBG_education_0001,
  PathBG_education_0002,
  PathBG_education_0003,
  PathBG_education_0004,
  PathBG_education_0005,
  PathBG_education_0006,
  PathBG_education_0007,
  PathBG_education_0008,
  PathBG_education_0009,
  PathBG_education_0010,
  PathBG_education_0011,
  PathBG_education_0012,
  PathBG_education_0013,
  PathBG_education_0014,
  PathBG_education_0015,
  PathBG_education_0016,
];

export const PathBG_EnterpriseSet: string[] = [
  PathBG_enterprise_0001,
  PathBG_enterprise_0002,
  PathBG_enterprise_0003,
  PathBG_enterprise_0004,
  PathBG_enterprise_0005,
  PathBG_enterprise_0006,
  PathBG_enterprise_0007,
  PathBG_enterprise_0008,
  PathBG_enterprise_0009,
  PathBG_enterprise_0010,
  PathBG_enterprise_0011,
  PathBG_enterprise_0012,
  PathBG_enterprise_0013,
  PathBG_enterprise_0014,
  PathBG_enterprise_0015,
  PathBG_enterprise_0016,
];

export const PathBG_EntertainmentSet: string[] = [
  PathBG_entertainment_0001,
  PathBG_entertainment_0002,
  PathBG_entertainment_0003,
  PathBG_entertainment_0004,
  PathBG_entertainment_0005,
  PathBG_entertainment_0006,
  PathBG_entertainment_0007,
  PathBG_entertainment_0008,
  PathBG_entertainment_0009,
  PathBG_entertainment_0010,
  PathBG_entertainment_0011,
  PathBG_entertainment_0012,
  PathBG_entertainment_0013,
  PathBG_entertainment_0014,
  PathBG_entertainment_0015,
  PathBG_entertainment_0016,
];

// function getAllPathBGInOrder(): string[] {
//   return [
//     ...PathBG_EntertainmentSet,
//     ...PathBG_EducationSet,
//     ...PathBG_EnterpriseSet,
//   ];
// }

function getAllPathBGInZipOrder() {
  const maxLength = Math.max(
    PathBG_EntertainmentSet.length,
    PathBG_EducationSet.length,
    PathBG_EnterpriseSet.length,
  );

  const combinedPaths = [];

  // 交错合并三个数组
  for (let i = 0; i < maxLength; i++) {
    // 添加对应索引的元素，如果存在
    if (i < PathBG_EntertainmentSet.length) {
      combinedPaths.push(PathBG_EntertainmentSet[i]);
    }
    if (i < PathBG_EducationSet.length) {
      combinedPaths.push(PathBG_EducationSet[i]);
    }
    if (i < PathBG_EnterpriseSet.length) {
      combinedPaths.push(PathBG_EnterpriseSet[i]);
    }
  }

  return combinedPaths;
}

// Function to get a path by index
export const getPathBGByIndex = (index: number): string | undefined => {
  const allPathsBGs = getAllPathBGInZipOrder();
  return allPathsBGs[index % allPathsBGs.length];
};
